export default {
  "site.name": "久久插",
  "site.tagline": "Durable Connection Solutions",
  "site.description": "Professional plug-in connection solutions for industrial, household, and construction applications.",
  "nav.home": "Home",
  "nav.products": "Products",
  "nav.articles": "Articles",
  "nav.about": "About",
  "nav.contact": "Contact",
  "hero.title": "Durable Connections, Worry-Free",
  "hero.subtitle": "Professional plug-in connection solutions for industrial, household, and construction applications. Built with superior craftsmanship and reliable materials.",
  "hero.cta": "View Products",
  "hero.secondary": "Learn More",
  "categories.title": "Product Categories",
  "categories.subtitle": "Six product series covering all connection needs",
  "categories.viewAll": "View All",
  "products.featured": "Featured Products",
  "products.featured.subtitle": "Market-proven bestsellers",
  "products.viewDetail": "View Details",
  "products.price": "Price",
  "advantages.title": "Why Choose Us",
  "advantages.subtitle": "Six core advantages for durable connections",
  "advantages.quality": "Superior Quality",
  "advantages.quality.desc": "ISO 9001 certified, full process quality control",
  "advantages.durability": "Long-Lasting",
  "advantages.durability.desc": "5,000-10,000 mating cycles, 10+ year lifespan",
  "advantages.protection": "Full Protection",
  "advantages.protection.desc": "IP68 waterproof, -40°C to 125°C temperature range",
  "advantages.custom": "Custom Solutions",
  "advantages.custom.desc": "From design to production, one-stop custom service",
  "advantages.safety": "Safety Certified",
  "advantages.safety.desc": "CCC/CE/UL multiple certifications",
  "advantages.support": "Professional Support",
  "advantages.support.desc": "24/7 technical support, 2-5 year warranty",
  "articles.latest": "Latest Articles",
  "articles.latest.subtitle": "Industry insights and practical guides from our team",
  "articles.readMore": "Read More",
  "articles.viewAll": "View All Articles",
  "faq.title": "FAQ",
  "faq.subtitle": "Common questions about our products and services",
  "cta.title": "Find Your Perfect Connection Solution",
  "cta.subtitle": "Our professional team is ready to assist you",
  "cta.button": "Contact Us",
  "footer.copyright": "© 2026 Jiujiucha. All rights reserved.",
  "footer.products": "Products",
  "footer.company": "Company",
  "footer.support": "Support",
  "footer.privacy": "Privacy Policy",
  "footer.terms": "Terms of Service",
  "category.all": "All",
  "category.products": " products",
  "breadcrumb.home": "Home",
  "about.title": "About Us",
  "about.story": "Our Story",
  "about.story.content": "Founded in 2008, we have been dedicated to connector R&D for 18 years.",
  "about.values": "Reputation",
  "about.values.cert": "Certifications",
  "about.values.cert.desc": "CCC, CE, UL, ISO 9001 certified",
  "about.values.clients": "Clients Served",
  "about.values.clients.desc": "10,000+ enterprise clients",
  "about.values.years": "Experience",
  "about.values.years.desc": "18 years of R&D expertise",
  "about.values.patents": "Patents",
  "about.values.patents.desc": "50+ national patents",
  "about.contact": "Contact Us",
  "about.contact.address": "Address",
  "about.contact.phone": "Phone",
  "about.contact.email": "Email",
  "about.contact.hours": "Business Hours",
  "about.contact.form": "Send Message",
  "about.contact.name": "Name",
  "about.contact.name.placeholder": "Your name",
  "about.contact.email.placeholder": "Your email",
  "about.contact.phone.placeholder": "Your phone",
  "about.contact.message": "Message",
  "about.contact.message.placeholder": "Your message (max 500 chars)",
  "about.contact.submit": "Submit",
  "about.contact.success": "Message sent! We'll get back to you soon.",
  "about.contact.error": "Submission failed. Please try again.",
  "articles.page.title": "Technical Articles",
  "articles.page.subtitle": "Industry insights, buying guides & application practices",
  "articles.search.placeholder": "Search articles...",
  "articles.noResults": "No articles found",
};